import { Link } from 'react-router-dom'
import { Card } from '../components/Card'
import { StatusMarker } from '../components/StatusMarker'
import { EmptyState } from '../components/EmptyState'
import { PageContainer } from '../components/PageContainer'
import { progressRepository } from '../../persistence/progressRepository'
import { buildLearningPathView, type LessonView } from '../viewModels/learningPath'
import styles from './LibraryScreen.module.css'

/** Library: completed lessons to revisit and lessons available to start. */
export function LibraryScreen() {
  const path = buildLearningPathView(progressRepository.load())
  const completed = path.lessons.filter((lesson) => lesson.status === 'completed')
  const available = path.lessons.filter(
    (lesson) => lesson.status === 'available' || lesson.status === 'in-progress',
  )

  return (
    <PageContainer title="Library" lede="Lessons you can start or revisit any time.">
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Available</h2>
        {available.length === 0 ? (
          <EmptyState title="Nothing available right now" />
        ) : (
          <ul className={styles.list}>
            {available.map((lesson) => (
              <LessonListItem key={lesson.id} lesson={lesson} />
            ))}
          </ul>
        )}
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Completed</h2>
        {completed.length === 0 ? (
          <EmptyState
            title="No completed lessons yet"
            description="Finish a lesson and it will be saved here for review."
          />
        ) : (
          <ul className={styles.list}>
            {completed.map((lesson) => (
              <LessonListItem key={lesson.id} lesson={lesson} />
            ))}
          </ul>
        )}
      </section>
    </PageContainer>
  )
}

function LessonListItem({ lesson }: { lesson: LessonView }) {
  return (
    <li>
      <Card>
        <Link to={`/lesson/${lesson.id}`} className={styles.itemLink}>
          <div className={styles.itemText}>
            <span className={styles.itemTitle}>{lesson.title}</span>
            <span className={styles.itemSummary}>{lesson.summary}</span>
          </div>
          <StatusMarker status={lesson.status} />
        </Link>
      </Card>
    </li>
  )
}
